/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DeviceHouseResponseDto } from './DeviceHouseResponseDto';
export type DeviceRoomResponseDto = {
  /**
   * Unique identifier of the room.
   */
  id: number;
  /**
   * Predefined name of the room (enum value).
   */
  name: DeviceRoomResponseDto.name;
  /**
   * Optional custom name assigned to the room.
   */
  customName?: string;
  /**
   * Associated house information, if available.
   */
  house?: DeviceHouseResponseDto;
};
export namespace DeviceRoomResponseDto {
  /**
   * Predefined name of the room (enum value).
   */
  export enum name {
    LIVING_ROOM = 'LIVING_ROOM',
    BEDROOM = 'BEDROOM',
    KITCHEN = 'KITCHEN',
    BATHROOM = 'BATHROOM',
    CHILDS_ROOM = 'CHILDS_ROOM',
    GARAGE = 'GARAGE',
    SUMMER_HOUSE = 'SUMMER_HOUSE',
    OTHER = 'OTHER',
  }
}

